import React, { useState, useEffect } from "react";
import axios from "axios";
import { CDCard, CDCardContent, CDCardHeader } from "../../const/CDCardStyles";
import { getCallsLogPaginated, exportCallsLog } from "../../const/CardDati";
import { CallsLogHeader } from "../../const/DatatableData";
import TableToolbar from "../UI/TableToolbar/TableToolbar";
import { Grid, Divider, Typography } from "@mui/material";
import { DataGrid, GridOverlay } from '@mui/x-data-grid';
import { styled } from "@mui/material/styles";
import FilterPanelDatatable from "./FilterPanelDatatable";
import CheckValidSortModel from '../../functions/CheckValidSortModel';
import { formatDate } from "../../functions/formatDate";
import { useDispatch } from 'react-redux';
import {notificationOpen}  from "../../redux/reducers/notification-reducer";
import Notification from "../UI/Notification/Notification";
import handlerError from "../../functions/handlerError";
import { calcPrevMonthDate } from "../../functions/ShortCutDate";


const StyledDataGrid = styled(DataGrid)(() => ({
    '& .MuiDataGrid-columnHeader:focus': {
      outline: 'none'
    }, 
    '& .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none'
    },
    '& .MuiDataGrid-root': {
      outline: 'none !important'
    },
    '& .MuiDataGrid-cell:focus-within':{
      outline: 'none !important'
    }
}));

const typePage="Chiamata";
let today = new Date();
const resultDate = calcPrevMonthDate(today);
const urlBase = process.env.REACT_APP_URL;
const columns = CallsLogHeader.headers;


const CallLogsDatatable = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rows, setRows] = useState([]);
  const [rowsCount, setRowsCount] = useState(rows.length);
  const [loading, setLoading] = useState(false);
  const [sortModel, setSortModel] = useState([{
    field: CallsLogHeader.initialFieldName,
    sort: CallsLogHeader.initialFieldOrder
  }]);
  const [filterParameters, setFilterParameters] = useState({
    startDate: resultDate.beginDate,
    endDate: resultDate.endDate,
    phoneNumber: '',
    deviceId: [],
    callType: []
  });

  const handleFilterData = (startDate, endDate, phoneNumber, selectedDevice, selectedCallTypes) => {
    let deviceToView = [];
    selectedDevice.map(device => deviceToView.push(device.idUtente));
  
    let callTypesToView = [];
    selectedCallTypes.map(callType => callTypesToView.push(callType.id));

    let newFilterParameters = {
      startDate: startDate,
      endDate: endDate,
      phoneNumber: phoneNumber,
      deviceId: deviceToView,
      callType: callTypesToView
    };

    setFilterParameters(newFilterParameters);
  };

  const handleDownloadXLS = () => {
      const { sortField, sortOrder } = CheckValidSortModel(sortModel, CallsLogHeader.initialFieldName);
      const { action, method } = exportCallsLog;
      const { startDate, endDate, phoneNumber, deviceId, callType } = filterParameters;
      let url = urlBase + action;

      const requestBody = {
        pageIndex: page,
        pageSize: pageSize,
        sortColumnName: sortField,
        sortDirection: sortOrder,
        applyPaginationAndSort: true,
        phoneNumber: phoneNumber,
        startDate: startDate,
        endDate: endDate,
        deviceId: deviceId,
        callType: callType
      };

      (async() => {
        try{
          const response = await axios({
            method: method,
            url,
            data: requestBody,
            responseType: 'blob'
          });
          
          const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          const blob = new Blob([response.data], { type: contentType });
          const urlDownload = window.URL.createObjectURL(blob);

          let a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = urlDownload;
          a.download = "Export-Chiamate-" + formatDate(today);
          a.click();
          window.URL.revokeObjectURL(url);

        } catch(error){
          console.error(error);
          const notificationError = handlerError(error)
          dispatch(notificationOpen(notificationError))
        } 
      })();
  }; 

  useEffect(() => {
    const { sortField, sortOrder } = CheckValidSortModel(sortModel, CallsLogHeader.initialFieldName);
    
    (async() => {
      setLoading(true);

      const { action, method } = getCallsLogPaginated;
      let url = urlBase + action;

      const { startDate, endDate, phoneNumber, deviceId, callType } = filterParameters;

      const requestBody = {
        pageIndex: page,
        pageSize: pageSize,
        sortColumnName: sortField,
        sortDirection: sortOrder,
        applyPaginationAndSort: true,
        startDate: startDate,
        endDate: endDate,
        phoneNumber: phoneNumber,
        deviceId: deviceId,
        callType: callType
      };

      try{
        const response = await axios({
          method: method,
          url,
          data: requestBody
        });
        
        const newRows = response.data.result.result;
        const newRowsCount = response.data.result.totalFiltered;
        setRows(newRows);
        setRowsCount(newRowsCount);
        if(!response.data.ok){
          dispatch(notificationOpen({message:response.data.message,status:response.data.ok }))
          }   
        } catch(error){
          console.error(error);
          const notificationError = handlerError(error)
          dispatch(notificationOpen(notificationError))
        } 
      
      setLoading(false);

    })();
  }, [page, pageSize, sortModel, filterParameters]);


  return (
    <>
      <Grid container item>
          <Grid item component={CDCard} xs={12} sm={12}>
              <CDCardHeader title="Registro chiamate" />
              <Divider />
              <CDCardContent>
                <FilterPanelDatatable handleFilterData={handleFilterData}/>
                <Divider sx={{mb:2}}/>
                <Grid container item>
                  <StyledDataGrid
                      rows={rows}
                      rowCount={rowsCount}
                      getRowId={(row) => row.id}
                      columns={columns}
                      page={page}
                      pageSize={pageSize}
                      onPageChange={(newPage) => setPage(newPage)}
                      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                      onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                      rowsPerPageOptions={[ 10, 25, 50, 100]}
                      disableSelectionOnClick
                      sortModel={sortModel}
                      sortingMode='server'
                      sortingOrder={['asc', 'desc']}
                      paginationMode='server'
                      loading={loading}
                      sx={{border: 0}}
                      disableColumnMenu
                      disableColumnFilter
                      disableColumnSelector
                      autoHeight
                      autoWidth
                      components={{
                          Toolbar: () => (
                            <TableToolbar downloadXLS={handleDownloadXLS}
                                          typePage={typePage} 
                                          enableExport={true}
                            />
                          ),
                          NoRowsOverlay: () => <GridOverlay>
                                                  <Typography>Nessuna riga</Typography>
                                              </GridOverlay>,
                          NoResultsOverlay: () => <GridOverlay>
                                                    <Typography>Nessuna riga</Typography>
                                                </GridOverlay>
                      }}
                  />
                </Grid>
              </CDCardContent>
          </Grid>
        <Notification />
        </Grid>
    </>
  );
};

export default CallLogsDatatable;
